export default __webpack_public_path__ + "static/media/puolesta-asiointi-lightblue.f3d5d583.svg";